<template>
    <page :tabs="tabs">
        <grid
            ref="grid"
            :columnDefs="columnDefs"
            :rowData="emailList"
            :isAutoWidth="isMobile"
            :isSearch="false"
            :suppressColumnVirtualisation="false"     
            @onGridReady="onGridReady"
        >
        </grid>
    </page>
</template>

<script>
import API from '../../../api';
import Grid from '../../generic/grid/grid.vue';
import Page from '../../generic/page/page.vue';
import {
    ADMIN_SYSTEM_EMAIL_LIST_ENDPOINT,
    ADMIN_SYSTEM_EMAIL_UPDATE_BY_ID_ENDPOINT,
} from '../../../endpoints';
import { isMediumScreen } from '../../../utils/screens';

export default {
    name: 'SystemEmailList',
    components: {
        Page,
        Grid,
    },
    data() {
        return {
            busy: false,
            tabs: [
                {
                    title: 'System Email',
                    active: true,
                    route: '/app/admin/system-email/',
                },
            ],
            emailList: [],
            currentSystemEmail: null,
            currentSystemEmailID: null,
        }
    },
    computed: {
        columnDefs() {
            return [
                {
                    headerName: '#',
                    maxWidth: 50,
                    minWidth: 50,
                    valueGetter: (params) => params.node.rowIndex + 1,
                },
                {
                    headerName: 'Title',
                    field: 'sysname',
                    minWidth: 200,
                    maxWidth: 350,
                    autoHeight: true,
                },
                {
                    headerName: 'Subject',
                    field: 'subject',
                    minWidth: 200,
                    maxWidth: 600,
                    autoHeight: true,
                },
                {
                    headerName: 'Body',
                    field: 'body_display',
                    minWidth: 300,
                    cellStyle: { whiteSpace: 'normal' },
                    cellRenderer: ({ data }) => {
                        return data.body_display;
                    },                    
                    autoHeight: true,
                    wrapText: true,
                }
            ]
        },
        isMobile() {
            return !this.isMediumScreen();
        }
    },
    mounted() {
        this.fetchSystemEmails()
    },
    methods: {
        isMediumScreen,
        onGridReady() {
            if (!this.isMobile) {
                const grid = this.$refs.grid;
                grid.gridOptions.api.sizeColumnsToFit();
            }
        },
        async fetchSystemEmails() {
            try {
                this.busy = true;
                const { data } = await API.get(ADMIN_SYSTEM_EMAIL_LIST_ENDPOINT());
                this.emailList = data
            } catch (e) {
                this.errorToast({ text: 'Could not load statuses' });
            } finally {
                this.busy = false;
            }
        },
        updateSystemEmail(payload) {
            return API.patch(ADMIN_SYSTEM_EMAIL_UPDATE_BY_ID_ENDPOINT(this.currentSystemEmailID), payload);
        },
        handleUpdateSystemEmailSuccess() {
            this.fetchSystemEmails()
        }
    }
}
</script>

<style lang="scss" scoped>

</style> 